import {
  ITransactionTypenames,
  Maybe,
  PayOverTimeTransactionState,
} from '@varo/graphql-schema-types';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { logErrorWithContext } from 'shared/utils/sentry/sentry';
import {
  ErrorSeverity,
  FeatureArea,
  ResponsibleTeam,
} from 'shared/utils/sentry/sentry.constants';

type TypedTransaction = {
  __typename?: string | null;
  id?: string;
  payOverTime?: Maybe<PayOverTimeTransactionState>;
};

export const getPayOverTimeState = (
  transaction?: Maybe<TypedTransaction>,
): PayOverTimeTransactionState | undefined =>
  transaction?.__typename === ITransactionTypenames.DebitCardTransaction
    ? (transaction.payOverTime ?? undefined)
    : undefined;

export enum AutopayConfirmationError {
  UnconfirmedOn = 'UnconfirmedOn',
  UnconfirmedOff = 'UnconfirmedOff',
}

export interface ErrorModel {
  screenType: ErrorScreenType;
  messageHeadline: string;
  messageBody: string;
}

export interface PayOverTimeErrorConfig extends ErrorModel {
  primaryButton: {
    title: string;
    onPress: () => void;
  };
}

export const buildErrorModel = (
  headline: string,
  body: string,
): ErrorModel => ({
  screenType: ErrorScreenType.Error,
  messageHeadline: headline,
  messageBody: body,
});

/**
 * Pay Over Time error copy is non-nullable in the schema, so the server signals "no copy"
 * with an empty string rather than null. Nullish coalescing does not catch that, which is
 * why blank copy has to be resolved explicitly.
 */
export const resolveErrorCopy = (
  copy: string | null | undefined,
  fallback: string,
): string => (copy?.trim() ? copy : fallback);

export const logPayOverTimeError = (
  error: unknown,
  additionalContext?: Record<string, unknown>,
  severity: ErrorSeverity = ErrorSeverity.HIGH,
) => {
  logErrorWithContext(error, {
    featureArea: FeatureArea.LENDING,
    responsibleTeam: ResponsibleTeam.LENDING_CREDIT,
    severity,
    additionalContext,
  });
};
